export default function Privacy(props) {
  
  
  return (
      <div className="pt-12">
        <div className="flex flex-col max-w-screen-lg mx-auto my-8">          
          <div className="bg-base border border-gray-800 rounded-t-xl overflow-hidden">
            <img src="/img/faq-bg.jpeg" alt=""/>
          </div>
          
          <div className="p-5 px-8 bg-base/80 border border-t-0 border-gray-800 rounded-b-xl relative leading-tight flex flex-col gap-5">                        
            <div>
              <p>
                <h4 className="text-xl font-bold my-3">Privacy Policy</h4>
              </p>

              <p className="text-sm text-green-500 mb-5">Last Updated: August 29, 2025</p>

              <p>
                Taian Table (“we,” “us,” or “our”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website (https://bookings.taian-table.com]) (the “Site”) or use our online reservation system. Please read this policy carefully. If you do not agree with the terms of this Privacy Policy, please do not access the Site or make reservations.
              </p>

              <h4 className="text-xl font-bold my-3">1. Information We Collect</h4>
              <p>We collect the following types of information:</p>
              <ul className="list-disc list-inside my-3">
                <li><strong>Personal Information:</strong> Information that identifies you, such as your name, email address, phone number, and any other details you provide when making a reservation or contacting us through the Site.</li>
                <li><strong>Reservation Information:</strong> Details related to your booking, such as the date, time, number of guests, and any special requests you submit through our online reservation system.</li>
                <li><strong>Non-Personal Information:</strong> Information that does not directly identify you, such as your browser type, IP address, device type, pages visited, and the date and time of your visit, collected automatically through cookies or similar technologies.</li>
                <li><strong>One-Time Passwords (OTPs):</strong> Temporary codes sent to your email to verify your identity during the reservation process.</li>
              </ul>

              <h4 className="text-xl font-bold my-3">2. How We Use Your Information</h4>
              <p>We use your information for the following purposes:</p>
              <ul className="list-disc list-inside my-3">
                <li>To process and confirm your reservations at Taian Table.</li>
                <li>To send you booking confirmations, reminders, and OTPs via email to facilitate your reservation.</li>
                <li>To respond to your inquiries or provide customer support.</li>
                <li>To improve the functionality and user experience of the Site.</li>
                <li>To comply with legal obligations or protect our legal rights.</li>
              </ul>

              <p>
                <strong>Note:</strong> We do not use your information to send marketing or promotional emails.
              </p>

              <h4 className="text-xl font-bold my-3">3. How We Share Your Information</h4>
              <p>We may share your information in the following circumstances:</p>

              <ul className="list-disc list-inside my-3">
                <li><strong>Service Providers:</strong> We may share your information with third-party service providers who assist with reservation management, email delivery, website hosting, or analytics. These providers are contractually obligated to protect your information and use it only for the services they provide to us.</li>
                <li><strong>Legal Requirements:</strong> We may disclose your information if required by law, such as in response to a court order, or to protect the rights, safety, or property of Taian Table, its customers, or others.</li>
                <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of the transaction.</li>
              </ul>

              <p>We do not sell your personal information to third parties.</p>

              <h4 className="text-xl font-bold my-3">4. Cookies and Tracking Technologies</h4>
              <p>
                We use cookies and similar technologies to enhance your experience, such as maintaining your session during the reservation process and analyzing Site usage. You can manage your cookie preferences through your browser settings, but disabling cookies may affect the Site’s functionality, including the ability to make reservations.                
              </p>

              <h4 className="text-xl font-bold my-3">5. Data Security</h4>
              <p>
                We implement reasonable technical and organizational measures to protect your personal information from unauthorized access, loss, or misuse. For example, we use secure encryption for OTPs and reservation data. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.
              </p>

              <h4 className="text-xl font-bold my-3">6. Your Choices</h4>
              <p>
                You may:
              </p>
              <ul className="list-disc list-inside my-3">
                <li>Request access, correction, or deletion of your personal information by contacting us at info@taian-table.cn</li>
                <li>Adjust cookie settings through your browser to limit or disable cookies.</li>
                <li>Provide only the information required to complete your reservation. You are not obligated to provide additional details, such as special requests.</li>
              </ul>
              <p>
                Since we do not send marketing emails, there is no need to opt out of promotional communications.
              </p>

              <h4 className="text-xl font-bold my-3">7. Data Retention</h4>
              <p>We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, such as completing your reservation and complying with legal obligations. For example, reservation data may be kept for a reasonable period to manage bookings or resolve disputes, after which it is securely deleted or anonymized.</p>

              <h4 className="text-xl font-bold my-3">8. Third-Party Links</h4>
              <p>The Site may contain links to third-party websites, such as payment processors or map services. We are not responsible for the privacy practices or content of these websites. We encourage you to review their privacy policies before providing any personal information.</p>

              <h4 className="text-xl font-bold my-3">9. Children’s Privacy</h4>
              <p>Our Site and reservation system are not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware of such information, we will take steps to delete it promptly.</p>

              <h4 className="text-xl font-bold my-3">10. International Data Transfers</h4>
              <p>If you are located outside China, your information may be transferred to and processed in China. We take steps to ensure that any international data transfers comply with applicable data protection laws.</p>

              <h4 className="text-xl font-bold my-3">11. Changes to This Privacy Policy</h4>
              <p>We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. The updated policy will be posted on this page with a revised “Last Updated” date. Your continued use of the Site or reservation system constitutes acceptance of the updated policy.</p>

              <h4 className="text-xl font-bold my-3">12. Contact Us</h4>
              <p>If you have questions or concerns about this Privacy Policy or how we handle your information, please contact us at: info@taian-table.cn</p>


            </div>
          </div>
        </div>
      </div>
  );
}